// package/generated.ts
var developmentCommunityClaimAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_allocationSetter", internalType: "address", type: "address" },
      { name: "_admin", internalType: "address", type: "address" },
      { name: "_claimStart", internalType: "uint256", type: "uint256" },
      { name: "_token", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "accountClaim",
    outputs: [
      {
        name: "",
        internalType: "struct IZoraTokenCommunityClaim.AccountClaim",
        type: "tuple",
        components: [
          { name: "allocation", internalType: "uint96", type: "uint96" },
          { name: "claimed", internalType: "bool", type: "bool" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "admin",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "allocationSetter",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "allocationSetupComplete",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "allocations",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "claimTo", internalType: "address", type: "address" }],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "claimIsOpen",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "claimStart",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "claimTo", internalType: "address", type: "address" },
      { name: "deadline", internalType: "uint256", type: "uint256" },
      { name: "signature", internalType: "bytes", type: "bytes" }
    ],
    name: "claimWithSignature",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "claimStart_", internalType: "uint256", type: "uint256" },
      { name: "transferBalanceFrom", internalType: "address", type: "address" }
    ],
    name: "completeAllocationSetup",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { name: "fields", internalType: "bytes1", type: "bytes1" },
      { name: "name", internalType: "string", type: "string" },
      { name: "version", internalType: "string", type: "string" },
      { name: "chainId", internalType: "uint256", type: "uint256" },
      { name: "verifyingContract", internalType: "address", type: "address" },
      { name: "salt", internalType: "bytes32", type: "bytes32" },
      { name: "extensions", internalType: "uint256[]", type: "uint256[]" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "getDomainSeparator",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "hasClaimed",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "nonce", internalType: "bytes32", type: "bytes32" }
    ],
    name: "nonceUsed",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "_users", internalType: "address[]", type: "address[]" }],
    name: "resetHasClaimed",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "packedData", internalType: "bytes32[]", type: "bytes32[]" }
    ],
    name: "setAllocations",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "packedData", internalType: "bytes32[]", type: "bytes32[]" },
      { name: "nonce", internalType: "bytes32", type: "bytes32" },
      { name: "signature", internalType: "bytes", type: "bytes" }
    ],
    name: "setAllocationsWithSignature",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "token",
    outputs: [{ name: "", internalType: "contract IERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "totalAllocated",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "claimStart_", internalType: "uint256", type: "uint256" }],
    name: "updateClaimStart",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "totalAllocation",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "claimStart",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "AllocationSetupCompleted"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "allocations",
        internalType: "bytes32[]",
        type: "bytes32[]",
        indexed: false
      }
    ],
    name: "AllocationsSet"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "claimTo",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Claimed"
  },
  { type: "event", anonymous: false, inputs: [], name: "EIP712DomainChanged" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "users",
        internalType: "address[]",
        type: "address[]",
        indexed: false
      }
    ],
    name: "ResetHasClaimed"
  },
  {
    type: "error",
    inputs: [{ name: "target", internalType: "address", type: "address" }],
    name: "AddressEmptyCode"
  },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "AddressInsufficientBalance"
  },
  { type: "error", inputs: [], name: "AllocationSetupAlreadyCompleted" },
  { type: "error", inputs: [], name: "AllocationSetupNotCompleted" },
  { type: "error", inputs: [], name: "AlreadyClaimed" },
  { type: "error", inputs: [], name: "ClaimNotOpen" },
  { type: "error", inputs: [], name: "ClaimOpened" },
  {
    type: "error",
    inputs: [
      { name: "claimStart", internalType: "uint256", type: "uint256" },
      { name: "currentTime", internalType: "uint256", type: "uint256" }
    ],
    name: "ClaimStartInPast"
  },
  { type: "error", inputs: [], name: "FailedInnerCall" },
  {
    type: "error",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "currentNonce", internalType: "bytes32", type: "bytes32" }
    ],
    name: "InvalidAccountNonce"
  },
  { type: "error", inputs: [], name: "InvalidShortString" },
  { type: "error", inputs: [], name: "InvalidSignature" },
  { type: "error", inputs: [], name: "InvalidToken" },
  { type: "error", inputs: [], name: "NoAllocation" },
  { type: "error", inputs: [], name: "OnlyAdmin" },
  { type: "error", inputs: [], name: "OnlyAllocationSetter" },
  {
    type: "error",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "SafeERC20FailedOperation"
  },
  {
    type: "error",
    inputs: [
      { name: "deadline", internalType: "uint256", type: "uint256" },
      { name: "currentTime", internalType: "uint256", type: "uint256" }
    ],
    name: "SignatureExpired"
  },
  {
    type: "error",
    inputs: [{ name: "str", internalType: "string", type: "string" }],
    name: "StringTooLong"
  }
];
var developmentCommunityClaimAddress = {
  8453: "0x63A230a6E60f880741df0348C73C9A5f56D71D44",
  84532: "0x2BfC7bc056d51746213F62CeBc16720FFda89F60"
};
var developmentCommunityClaimConfig = {
  address: developmentCommunityClaimAddress,
  abi: developmentCommunityClaimAbi
};
var zoraAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_initializerAccount", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "CLOCK_MODE",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "spender", internalType: "address", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "spender", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "pos", internalType: "uint32", type: "uint32" }
    ],
    name: "checkpoints",
    outputs: [
      {
        name: "",
        internalType: "struct Checkpoints.Checkpoint208",
        type: "tuple",
        components: [
          { name: "_key", internalType: "uint48", type: "uint48" },
          { name: "_value", internalType: "uint208", type: "uint208" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "clock",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "contractURI",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", internalType: "uint8", type: "uint8" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "delegatee", internalType: "address", type: "address" }],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "delegatee", internalType: "address", type: "address" },
      { name: "nonce", internalType: "uint256", type: "uint256" },
      { name: "expiry", internalType: "uint256", type: "uint256" },
      { name: "v", internalType: "uint8", type: "uint8" },
      { name: "r", internalType: "bytes32", type: "bytes32" },
      { name: "s", internalType: "bytes32", type: "bytes32" }
    ],
    name: "delegateBySig",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "delegates",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { name: "fields", internalType: "bytes1", type: "bytes1" },
      { name: "name", internalType: "string", type: "string" },
      { name: "version", internalType: "string", type: "string" },
      { name: "chainId", internalType: "uint256", type: "uint256" },
      { name: "verifyingContract", internalType: "address", type: "address" },
      { name: "salt", internalType: "bytes32", type: "bytes32" },
      { name: "extensions", internalType: "uint256[]", type: "uint256[]" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "timepoint", internalType: "uint256", type: "uint256" }],
    name: "getPastTotalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "timepoint", internalType: "uint256", type: "uint256" }
    ],
    name: "getPastVotes",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "getVotes",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "tos", internalType: "address[]", type: "address[]" },
      { name: "amounts", internalType: "uint256[]", type: "uint256[]" },
      { name: "contractURI_", internalType: "string", type: "string" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "nonces",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "numCheckpoints",
    outputs: [{ name: "", internalType: "uint32", type: "uint32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "spender", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "deadline", internalType: "uint256", type: "uint256" },
      { name: "v", internalType: "uint8", type: "uint8" },
      { name: "r", internalType: "bytes32", type: "bytes32" },
      { name: "s", internalType: "bytes32", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "spender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "value",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Approval"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "delegator",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "fromDelegate",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "toDelegate",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "DelegateChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "delegate",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "previousVotes",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "newVotes",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "DelegateVotesChanged"
  },
  { type: "event", anonymous: false, inputs: [], name: "EIP712DomainChanged" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "version",
        internalType: "uint64",
        type: "uint64",
        indexed: false
      }
    ],
    name: "Initialized"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      {
        name: "value",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Transfer"
  },
  { type: "error", inputs: [], name: "CheckpointUnorderedInsertion" },
  { type: "error", inputs: [], name: "ECDSAInvalidSignature" },
  {
    type: "error",
    inputs: [{ name: "length", internalType: "uint256", type: "uint256" }],
    name: "ECDSAInvalidSignatureLength"
  },
  {
    type: "error",
    inputs: [{ name: "s", internalType: "bytes32", type: "bytes32" }],
    name: "ECDSAInvalidSignatureS"
  },
  {
    type: "error",
    inputs: [
      { name: "increasedSupply", internalType: "uint256", type: "uint256" },
      { name: "cap", internalType: "uint256", type: "uint256" }
    ],
    name: "ERC20ExceededSafeSupply"
  },
  {
    type: "error",
    inputs: [
      { name: "spender", internalType: "address", type: "address" },
      { name: "allowance", internalType: "uint256", type: "uint256" },
      { name: "needed", internalType: "uint256", type: "uint256" }
    ],
    name: "ERC20InsufficientAllowance"
  },
  {
    type: "error",
    inputs: [
      { name: "sender", internalType: "address", type: "address" },
      { name: "balance", internalType: "uint256", type: "uint256" },
      { name: "needed", internalType: "uint256", type: "uint256" }
    ],
    name: "ERC20InsufficientBalance"
  },
  {
    type: "error",
    inputs: [{ name: "approver", internalType: "address", type: "address" }],
    name: "ERC20InvalidApprover"
  },
  {
    type: "error",
    inputs: [{ name: "receiver", internalType: "address", type: "address" }],
    name: "ERC20InvalidReceiver"
  },
  {
    type: "error",
    inputs: [{ name: "sender", internalType: "address", type: "address" }],
    name: "ERC20InvalidSender"
  },
  {
    type: "error",
    inputs: [{ name: "spender", internalType: "address", type: "address" }],
    name: "ERC20InvalidSpender"
  },
  {
    type: "error",
    inputs: [{ name: "deadline", internalType: "uint256", type: "uint256" }],
    name: "ERC2612ExpiredSignature"
  },
  {
    type: "error",
    inputs: [
      { name: "signer", internalType: "address", type: "address" },
      { name: "owner", internalType: "address", type: "address" }
    ],
    name: "ERC2612InvalidSigner"
  },
  {
    type: "error",
    inputs: [
      { name: "timepoint", internalType: "uint256", type: "uint256" },
      { name: "clock", internalType: "uint48", type: "uint48" }
    ],
    name: "ERC5805FutureLookup"
  },
  { type: "error", inputs: [], name: "ERC6372InconsistentClock" },
  { type: "error", inputs: [], name: "InitializerCannotBeAddressZero" },
  {
    type: "error",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "currentNonce", internalType: "uint256", type: "uint256" }
    ],
    name: "InvalidAccountNonce"
  },
  { type: "error", inputs: [], name: "InvalidInitialization" },
  { type: "error", inputs: [], name: "InvalidInputLengths" },
  { type: "error", inputs: [], name: "InvalidShortString" },
  { type: "error", inputs: [], name: "NotInitializing" },
  { type: "error", inputs: [], name: "OnlyAdmin" },
  {
    type: "error",
    inputs: [
      { name: "bits", internalType: "uint8", type: "uint8" },
      { name: "value", internalType: "uint256", type: "uint256" }
    ],
    name: "SafeCastOverflowedUintDowncast"
  },
  {
    type: "error",
    inputs: [{ name: "str", internalType: "string", type: "string" }],
    name: "StringTooLong"
  },
  { type: "error", inputs: [], name: "URINeedsToBeSet" },
  {
    type: "error",
    inputs: [{ name: "expiry", internalType: "uint256", type: "uint256" }],
    name: "VotesExpiredSignature"
  }
];
var zoraAddress = {
  8453: "0x1111111111166b7FE7bd91427724B487980aFc69",
  73571: "0x1111111111166b7FE7bd91427724B487980aFc69",
  84532: "0xa5EAd88ABb76aa1e582329D7C0ab057511c6Aac2"
};
var zoraConfig = { address: zoraAddress, abi: zoraAbi };
var zoraTokenCommunityClaimAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_allocationSetter", internalType: "address", type: "address" },
      { name: "_admin", internalType: "address", type: "address" },
      { name: "_token", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "accountClaim",
    outputs: [
      {
        name: "",
        internalType: "struct IZoraTokenCommunityClaim.AccountClaim",
        type: "tuple",
        components: [
          { name: "allocation", internalType: "uint96", type: "uint96" },
          { name: "claimed", internalType: "bool", type: "bool" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "admin",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "allocationSetter",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "allocationSetupComplete",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "allocations",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "claimTo", internalType: "address", type: "address" }],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "claimIsOpen",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "claimStart",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "claimTo", internalType: "address", type: "address" },
      { name: "deadline", internalType: "uint256", type: "uint256" },
      { name: "signature", internalType: "bytes", type: "bytes" }
    ],
    name: "claimWithSignature",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "claimStart_", internalType: "uint256", type: "uint256" },
      { name: "transferBalanceFrom", internalType: "address", type: "address" }
    ],
    name: "completeAllocationSetup",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { name: "fields", internalType: "bytes1", type: "bytes1" },
      { name: "name", internalType: "string", type: "string" },
      { name: "version", internalType: "string", type: "string" },
      { name: "chainId", internalType: "uint256", type: "uint256" },
      { name: "verifyingContract", internalType: "address", type: "address" },
      { name: "salt", internalType: "bytes32", type: "bytes32" },
      { name: "extensions", internalType: "uint256[]", type: "uint256[]" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "getDomainSeparator",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "hasClaimed",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "nonce", internalType: "bytes32", type: "bytes32" }
    ],
    name: "nonceUsed",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "packedData", internalType: "bytes32[]", type: "bytes32[]" }
    ],
    name: "setAllocations",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "packedData", internalType: "bytes32[]", type: "bytes32[]" },
      { name: "nonce", internalType: "bytes32", type: "bytes32" },
      { name: "signature", internalType: "bytes", type: "bytes" }
    ],
    name: "setAllocationsWithSignature",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "token",
    outputs: [{ name: "", internalType: "contract IERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "totalAllocated",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "claimStart_", internalType: "uint256", type: "uint256" }],
    name: "updateClaimStart",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "totalAllocation",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "claimStart",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "AllocationSetupCompleted"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "allocations",
        internalType: "bytes32[]",
        type: "bytes32[]",
        indexed: false
      }
    ],
    name: "AllocationsSet"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "claimTo",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Claimed"
  },
  { type: "event", anonymous: false, inputs: [], name: "EIP712DomainChanged" },
  {
    type: "error",
    inputs: [{ name: "target", internalType: "address", type: "address" }],
    name: "AddressEmptyCode"
  },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "AddressInsufficientBalance"
  },
  { type: "error", inputs: [], name: "AllocationSetupAlreadyCompleted" },
  { type: "error", inputs: [], name: "AllocationSetupNotCompleted" },
  { type: "error", inputs: [], name: "AlreadyClaimed" },
  { type: "error", inputs: [], name: "ClaimNotOpen" },
  { type: "error", inputs: [], name: "ClaimOpened" },
  {
    type: "error",
    inputs: [
      { name: "claimStart", internalType: "uint256", type: "uint256" },
      { name: "currentTime", internalType: "uint256", type: "uint256" }
    ],
    name: "ClaimStartInPast"
  },
  { type: "error", inputs: [], name: "FailedInnerCall" },
  {
    type: "error",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "currentNonce", internalType: "bytes32", type: "bytes32" }
    ],
    name: "InvalidAccountNonce"
  },
  { type: "error", inputs: [], name: "InvalidShortString" },
  { type: "error", inputs: [], name: "InvalidSignature" },
  { type: "error", inputs: [], name: "InvalidToken" },
  { type: "error", inputs: [], name: "NoAllocation" },
  { type: "error", inputs: [], name: "OnlyAdmin" },
  { type: "error", inputs: [], name: "OnlyAllocationSetter" },
  {
    type: "error",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "SafeERC20FailedOperation"
  },
  {
    type: "error",
    inputs: [
      { name: "deadline", internalType: "uint256", type: "uint256" },
      { name: "currentTime", internalType: "uint256", type: "uint256" }
    ],
    name: "SignatureExpired"
  },
  {
    type: "error",
    inputs: [{ name: "str", internalType: "string", type: "string" }],
    name: "StringTooLong"
  }
];
var zoraTokenCommunityClaimAddress = {
  8453: "0x0000000002ba96C69b95E32CAAB8fc38bAB8B3F8",
  73571: "0x5d93fC4DdECADae39AD172F21C873F407536E6E2",
  84532: "0xbaC462F313850b5Eeb88201f7B22FDc8f293C807"
};
var zoraTokenCommunityClaimConfig = {
  address: zoraTokenCommunityClaimAddress,
  abi: zoraTokenCommunityClaimAbi
};

// package/typedData.ts
var TypedDataDomain = "ZoraTokenCommunityClaim";
var TypedDataVersion = "1";
var permitClaimTypedDataDefinition = ({
  message,
  chainId,
  claimContract
}) => {
  const typesAndMessage = {
    types: {
      ClaimWithSignature: [
        { name: "user", type: "address" },
        { name: "claimTo", type: "address" },
        { name: "deadline", type: "uint256" }
      ]
    },
    message,
    primaryType: "ClaimWithSignature"
  };
  return {
    ...typesAndMessage,
    domain: {
      chainId,
      name: TypedDataDomain,
      version: TypedDataVersion,
      verifyingContract: claimContract
    }
  };
};
var setAllocationsTypedDataDefinition = ({
  message,
  chainId,
  claimContract
}) => {
  const typesAndMessage = {
    types: {
      SetAllocations: [
        { name: "packedData", type: "bytes32[]" },
        { name: "nonce", type: "bytes32" }
      ]
    },
    message,
    primaryType: "SetAllocations"
  };
  return {
    ...typesAndMessage,
    domain: {
      chainId,
      name: TypedDataDomain,
      version: TypedDataVersion,
      verifyingContract: claimContract
    }
  };
};
export {
  developmentCommunityClaimAbi,
  developmentCommunityClaimAddress,
  developmentCommunityClaimConfig,
  permitClaimTypedDataDefinition,
  setAllocationsTypedDataDefinition,
  zoraAbi,
  zoraAddress,
  zoraConfig,
  zoraTokenCommunityClaimAbi,
  zoraTokenCommunityClaimAddress,
  zoraTokenCommunityClaimConfig
};
//# sourceMappingURL=index.js.map